export function getRoleHomePath(role) {
    if (role === 'super_admin')        return '/super-admin';
    if (role === 'tenant_admin')       return '/tenant-admin';
    if (role === 'auditor')            return '/auditor';
    if (role === 'compliance_officer') return '/compliance';
    if (role === 'manager')            return '/manager';
    if (role === 'executive')          return '/executive';
    if (role === 'external_regulator') return '/regulator-report';
    return '/dashboard';
}
